"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chapter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _player = _interopRequireDefault(require("@vimeo/player"));
var _all = require("gsap/all");
var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
_all.gsap.registerPlugin(_all.ScrollTrigger);
const PROPORTION = 16 / 9;
const VideoBackground = ({
  vimeoId
}) => {
  const videoContainer = (0, _react.useRef)(null);
  const player = (0, _react.useRef)(null);
  const initVideo = () => {
    if (player.current) {
      player.current.destroy();
    }
    let w, h;
    const wp = window.innerWidth / window.innerHeight;
    if (PROPORTION > wp) {
      h = window.innerHeight;
      w = h * PROPORTION;
    } else {
      w = window.innerWidth;
      h = w / PROPORTION;
    }
    const vimeoOptions = {
      title: false,
      controls: true,
      byline: false,
      autoplay: true,
      autopause: false,
      muted: true,
      loop: true,
      width: w,
      height: h
    };
    player.current = new _player.default(videoContainer.current, {
      id: vimeoId,
      ...vimeoOptions
    });
    return () => {
      player.current.destroy();
    };
  };
  (0, _react.useEffect)(() => {
    if (vimeoId) {
      const cleanup = initVideo();
      return cleanup;
    }
  }, [vimeoId]);
  return _react.default.createElement(_styles.VideoContainer, {
    ref: videoContainer
  });
};
const Chapter = ({
  id,
  textColor,
  backgroundImage,
  backgroundColor,
  vimeoId,
  initTimelines,
  scrollContainerId,
  children
}) => {
  const pinRef = (0, _react.useRef)(null);
  const triggerRef = (0, _react.useRef)(null);
  const pinTlRef = (0, _react.useRef)(null);
  const initPinTl = () => {
    console.log('iint');
    if (pinTlRef.current) {
      pinTlRef.current.scrollTrigger?.kill(true);
      pinTlRef.current.kill(true);
    }
    let scrollTriggerOptions = {
      trigger: triggerRef.current,
      start: 'top top',
      end: 'bottom bottom',
      pin: pinRef.current,
      pinSpacing: false,
      onToggle: self => {
        if (self.isActive && self.direction === 1) {
          pinRef.current?.classList.add('is-active');
        }
        if (!self.isActive && self.direction === -1) {
          pinRef.current?.classList.remove('is-active');
        }
      }
    };
    if (scrollContainerId && document.querySelector(`#${scrollContainerId}`)) {
      scrollTriggerOptions.scroller = document.querySelector(`#${scrollContainerId}`);
    }
    pinTlRef.current = _all.gsap.timeline().to(pinRef.current, {
      scrollTrigger: scrollTriggerOptions,
      duration: 1
    });
  };
  const debounceResize = (0, _lodash.debounce)(() => {
    if (window?.innerWidth >= 768) {
      initPinTl();
    } else {
      if (pinTlRef.current) {
        pinTlRef.current.scrollTrigger?.kill(true);
        pinTlRef.current.kill();
      }
    }
  }, 200);
  (0, _react.useEffect)(() => {
    if (initTimelines) {
      window.addEventListener('resize', debounceResize);
      if (window?.innerWidth >= 768) {
        setTimeout(initPinTl, 150);
      }
      return () => {
        window.removeEventListener('resize', debounceResize);
        if (pinTlRef.current) {
          pinTlRef.current.scrollTrigger?.kill(true);
          pinTlRef.current.kill();
        }
      };
    }
  }, [initTimelines]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.Section, {
    id: id,
    ref: triggerRef,
    backgroundColor: backgroundColor?.hex,
    textColor: textColor?.hex
  }, _react.default.createElement(_styles.Hero, {
    ref: pinRef,
    backgroundColor: backgroundColor?.hex,
    backgroundImage: backgroundImage?.src
  }, vimeoId && _react.default.createElement(VideoBackground, {
    vimeoId: vimeoId
  })), _react.default.createElement(_styles.ChildrenContainer, null, children)));
};
exports.Chapter = Chapter;
//# sourceMappingURL=index.js.map